import React from 'react';
import { Navigate } from 'react-router-dom';
import useUserPermissions from '../hooks/useUserPermissions';

/**
 * Route guard for Runbook pages.
 *
 * Access is controlled by canAccessRunbooks in useUserPermissions and applies
 * to direct URL entry as well.
 *
 * While the auth token is still being decoded (isLoading) we render nothing to
 * avoid a flash-redirect before permissions are known.
 */
function RunbookRoute({ children }) {
  const { canAccessRunbooks, isLoading } = useUserPermissions();

  if (isLoading) return null;

  if (!canAccessRunbooks()) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default RunbookRoute;
